import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "../styles/CustomNavbar.css";

const CustomNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const [activeHash, setActiveHash] = useState(window.location.hash);

  const isHashActive = (hash) => {
    // We only mark the link active if the user is on "/" *and* the hash matches
    return location.pathname === "/" && location.hash === hash;
  };

  const handleHashClick = (hash) => {
    setActiveHash(hash);
    navigate(`/${hash}`);
    closeMenu(); // for mobile
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    // Disable scrolling when the menu is open
    if (!isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  };

  // New function: Closes the mobile menu and re-enables scrolling
  const closeMenu = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  // Clean up: Ensure that body scrolling is enabled when component is unmounted
  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      setActiveHash(hash);
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange(); // set initial hash

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (location.pathname !== "/") {
      setActiveHash(""); // desactivar los hash si no estás en la Home
    }
  }, [location.pathname]);

  return (
    <div>
      {/* Desktop Navbar */}
      <div className="navbar desktop-navbar">
        <div className="logo">
          <a
            href="https://nexavista.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/static/images/logo.svg"
              alt="NexaVista Logo"
              className="logo-image"
            />
          </a>
        </div>

        <div className="nav-links">
          <a
            href="#growth-stories"
            onClick={(e) => {
              e.preventDefault();
              handleHashClick("#growth-stories");
            }}
            className={activeHash === "#growth-stories" ? "activeLink" : ""}
          >
            Growth Stories
          </a>

          <a
            href="#grow-with-us"
            onClick={(e) => {
              e.preventDefault();
              handleHashClick("#grow-with-us");
            }}
            className={activeHash === "#grow-with-us" ? "activeLink" : ""}
          >
            Grow with Us
          </a>

          <NavLink
            to="/academy"
            className={({ isActive }) => (isActive ? "activeLink" : "")}
            onClick={closeMenu}
          >
            Academy
          </NavLink>

          <NavLink
            to="/strategies"
            className={({ isActive }) => (isActive ? "activeLink" : "")}
            onClick={closeMenu}
          >
            Strategies
          </NavLink>
          <button className="evaluate-button">Evaluate Your Business</button>
        </div>
      </div>

      {/* Mobile Navbar */}
      <nav className="mobile-navbar">
        <div className="navbar-logo">
          <a href="https://nexavista.co.uk" rel="noopener noreferrer">
            <img src="static/images/logo.png" alt="Logo" />
          </a>
        </div>
        <div
          className={`hamburger ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul className={`navbar-links ${isOpen ? "open" : ""}`}>
          <li>
            <a
              href="#growth-stories"
              onClick={(e) => {
                e.preventDefault();
                handleHashClick("#growth-stories");
              }}
              className={activeHash === "#growth-stories" ? "activeLink" : ""}
            >
              Growth Stories
            </a>
          </li>
          <li>
            <a
              href="#grow-with-us"
              onClick={(e) => {
                e.preventDefault();
                handleHashClick("#grow-with-us");
              }}
              className={activeHash === "#grow-with-us" ? "activeLink" : ""}
            >
              Grow with Us
            </a>
          </li>
          <li>
            <NavLink to="/academy" onClick={closeMenu}>
              Academy
            </NavLink>
          </li>
          <li>
            <NavLink to="/strategies" onClick={closeMenu}>
              Strategies
            </NavLink>
          </li>
          <li>
            <button className="evaluate-button-mobile">
              Evaluate Your Business
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default CustomNavbar;
